import { render, staticRenderFns } from "./optometryHome.vue?vue&type=template&id=3096a7f3&scoped=true&"
import script from "./optometryHome.vue?vue&type=script&lang=js&"
export * from "./optometryHome.vue?vue&type=script&lang=js&"
import style0 from "./optometryHome.vue?vue&type=style&index=0&id=3096a7f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3096a7f3",
  null
  
)

export default component.exports